<template>
  <div class="columns is-multiline is-mobile">
    <div class="column is-full-mobile is-6-desktop ">
        <vue-adsense
        ad-style="display:block"
        ad-client="ca-pub-8717113253404092"
        ad-slot="7401582331"
        ad-format="auto">
      </vue-adsense>
      <br/>
      <base-card
        :title="capstitle" :content="getDescription(file)">
        <card-footer-item slot="footer" v-if="file.userid" :href="'https://flb.st/' + $route.params.fileid"
                          class="short-link"
                          data-label="Copied"
                          @click.native.prevent="copyUrl">
          <span class="icon is-small">
            <i aria-hidden="true" class="fa fa-share-alt"></i>
          </span>&nbsp;&nbsp;
          Short Link
        </card-footer-item>
        <card-footer-item slot="footer" v-if="file.userid" :href="'/download/'+file.userid+'/'+file.name">
          <span class="icon is-small">
            <i aria-hidden="true" class="fa fa-link"></i>
          </span>&nbsp;&nbsp;
          Download
        </card-footer-item>
      </base-card>
      <vue-adsense
        ad-style="display:block"
        ad-client="ca-pub-8717113253404092"
        ad-slot="7401582331"
        ad-format="auto">
      </vue-adsense>
      <br/>
      <!-- <vue-disqus shortname="filesbeast"></vue-disqus> -->
    </div>
    <div class="column is-full-mobile is-4-desktop is-offset-sidebar-desktop">
      <div>
        <h1 class="title">Popular Uploads</h1>
        <collapse accordion>
          <collapse-item v-for="file in popularfiles" :title="file.name | capitalize" :key="file.randname">
            <div class="is-inline-block">
              <strong>Size</strong><br/>
              <span class="filedata">{{ file.size | prettyBytes }}</span>
            </div>

            <div class="is-inline-block">
              <strong>Downloads</strong><br/>
              <span class="filedata">{{ file.downloads | formatNumber }}</span>
            </div>
            <div class="is-inline-block">
              <a :href="'/file/'+file.randname"><i :style="'margin-left:18%;'"
                                                   class="fa fa-lg fa-cloud-download"></i> </a>
            </div>
          </collapse-item>
        </collapse>
      </div>
      <br/>
      <div class="adcode2">
        <span>
          <vue-adsense
            ad-style="display:block"
            ad-client="ca-pub-8717113253404092"
            ad-slot="6696673629"
            ad-format="auto">
          </vue-adsense>
        </span>
      </div>
      <h1 class="title">Recent Uploads</h1>
      <collapse accordion>
        <collapse-item v-for="file in recentfiles" :title="file.name | capitalize" :key="file.randname">
          <div class="is-inline-block">
            <strong>Size</strong><br/>
            <span class="filedata">{{ file.size | prettyBytes }}</span>
          </div>

          <div class="is-inline-block">
            <strong>Downloads</strong><br/>
            <span class="filedata">{{ file.downloads | formatNumber }}</span>
          </div>
          <div class="is-inline-block">
            <a :href="'/file/'+file.randname"><i :style="'margin-left:18%;'"
                                                 class="fa fa-lg fa-cloud-download"></i> </a>
          </div>
        </collapse-item>
      </collapse>
    </div>
  </div>
</template>
<script>
  import { BaseCard, CardFooterItem } from 'vue-bulma-card'
  // import VueDisqus from 'vue-disqus'
  import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
  import VueAdsense from 'vue-adsense'
  export default {
    components: {
      BaseCard,
      CardFooterItem,
      // VueDisqus,
      Collapse,
      CollapseItem,
      VueAdsense
    },
    data () {
      return {
        file: {
          name: ''
        },
        popularfiles: [],
        recentfiles: []
      }
    },
    beforeCreate () {
      this.$http({
        url: '/api/v1/file/' + this.$route.params.fileid,
        transformResponse: [(data) => {
          return JSON.parse(data.replace(/T00:00:00Z/g, ''))
        }]
      }).then((response) => {
        this.file = response.data

        if (typeof response.data.success !== 'undefined') {
          this.$router.push('/')
        }
      }).catch((error) => {
        console.log(error)
      })

      // fetch popular files
      this.$http({
        url: '/api/v1/search/popular',
        transformResponse: [(data) => {
          return JSON.parse(data.replace(/T00:00:00Z/g, ''))
        }]
      }).then((response) => {
        this.popularfiles = response.data.files
      }).catch((error) => {
        console.log(error)
      })

      // recent files
      this.$http({
        url: '/api/v1/page/1',
        transformResponse: [(data) => {
          return JSON.parse(data.replace(/T00:00:00Z/g, ''))
        }]
      }).then((response) => {
        this.recentfiles = response.data.files
      }).catch((error) => {
        console.log(error)
      })
    },
    computed: {
      capstitle: function () {
        // `this` points to the vm instance
        let tooltip = '&nbsp; <img class="trustimage" src="/assets/img/trust.png" alt="trust" title="All files are first tested by our administrators and only then uploaded. The files are completely safe and secure to download and use.">'
        return this.file.name.toUpperCase() + tooltip
      }
    },
    metaInfo () {
      return {
        title: 'Download ' + this.file.name,
        // override the parent template and just use the above title only
        titleTemplate: null,
        meta: [
          {name: 'keywords', content: this.file.tags},
          {name: 'description', content: 'You can download ' + this.file.name + ' from FilesBeast for free. No speed limits.'},
          {name: 'twitter:card', content: 'Summary'},
          {name: 'twitter:description', content: 'You can download ' + this.file.name + ' from FilesBeast. No speed limits.'},
          {name: 'twitter:title', content: 'Download ' + this.file.name + ' from FilesBeast'},
          {property: 'og:locale', content: 'en_US'},
          {property: 'og:title', content: 'FilesBeast | Fast Free Downloads'},
          {property: 'og:site_name', content: 'FilesBeast | Fast Free Downloads'},
          {property: 'og:type', content: 'website'},
          {property: 'og:url', content: 'https://filesbeast.net' + window.location.pathname}
        ]
      }
    },
    methods: {
      prettyBytes (num) {
        // jacked from: https://github.com/sindresorhus/pretty-bytes

        if (typeof num !== 'number') {
          throw new TypeError('Expected a number')
        }

        let exponent
        let unit
        let neg = num < 0
        let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        if (neg) {
          num = -num
        }

        if (num < 1) {
          return (neg ? '-' : '') + num + ' B'
        }

        exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1)
        num = (num / Math.pow(1024, exponent)).toFixed(2) * 1
        unit = units[exponent]

        return (neg ? '-' : '') + num + ' ' + unit
      },
      getDescription (file) {
        let desc = '<div class="LOADINGBGWRAPPER LOADINGBGCONTENT2"></div>' +
          '<br/><div class="LOADINGBGWRAPPER LOADINGBGCONTENT4"></div>' +
          '<br/><div class="LOADINGBGWRAPPER LOADINGBGCONTENT3"></div>'
        if (file.size !== undefined) {
          desc = '<span class="filedata"><strong>Size</strong><br/>' + this.prettyBytes(parseInt(file.size)) + '</span>'
          desc += '<br/><span class="filedata"><strong>Downloads</strong><br/>' + file.downloads + '</span>'
          desc += '<br/><span class="filedata"><strong>MD5 Hash</strong><br/><span class="filecode"> ' + file.hash + '</span></span>'
          desc += '<br/><span class="filedata"><strong>Upload Date</strong><br/>' + file.created_on + '</span>'
        }
        return desc
      },
      copyUrl () {
        let copyText = 'https://flb.st/' + this.$route.params.fileid
        let mark, selection, range
        try {
          let range = document.createRange()
          let selection = document.getSelection()

          mark = document.createElement('span')
          mark.textContent = copyText
          // reset user styles for span element
          mark.style.all = 'unset'
          // prevents scrolling to the end of the page
          mark.style.position = 'fixed'
          mark.style.top = 0
          mark.style.clip = 'rect(0, 0, 0, 0)'
          // used to preserve spaces and line breaks
          mark.style.whiteSpace = 'pre'
          // do not inherit user-select (it may be `none`)
          mark.style.webkitUserSelect = 'text'
          mark.style.MozUserSelect = 'text'
          mark.style.msUserSelect = 'text'
          mark.style.userSelect = 'text'

          document.body.appendChild(mark)

          range.selectNode(mark)
          selection.addRange(range)

          let successful = document.execCommand('copy')
          if (!successful) {
            throw new Error('copy command was unsuccessful')
          }
        } catch (err) {
          try {
            window.clipboardData.setData('text', copyText)
          } catch (err) {
            console.log('unable to copy')
          }
        } finally {
          if (selection) {
            if (typeof selection.removeRange === 'function') {
              selection.removeRange(range)
            } else {
              selection.removeAllRanges()
            }
          }
          let d = document.getElementsByClassName('short-link')
          d[0].className += ' copying'
          setTimeout(function () {
            d[0].className = 'short-link card-footer-item'
          }, 500)
          mark.blur()
          if (mark) {
            document.body.removeChild(mark)
          }
        }
      }
    }
  }
</script>
<style lang="scss" >
  .filedata {
    line-height: 1.8rem;
  }

  .filecode {
    background-color: #E8F5F2;
    padding: 2px 4px;
    border-radius: 5px;
    font-size: 90%;
    color: #1BC1A1;
  }

  .trustimage {
    height: 1.5rem;
  }

  .TIMELINE-ITEM {
    background: #fff;
    border: 1px solid;
    border-color: #e5e6e9 #dfe0e4 #d0d1d5;
    border-radius: 3px;
    padding: 12px;

    margin: 0 auto;
    max-width: 472px;
    min-height: 200px;
  }

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0
    }
    100% {
      background-position: 468px 0
    }
  }

  @keyframes floatup {
    20% {
      opacity: .999
    }

    100% {
      -webkit-transform: translate3d(-50%, -17px, 0);
      transform: translate3d(-50%, -17px, 0)
    }
  }

  @-webkit-keyframes floatup {
    20% {
      opacity: .999
    }

    100% {
      -webkit-transform: translate3d(-50%, -17px, 0);
      transform: translate3d(-50%, -17px, 0)
    }
  }

  .LOADINGBGWRAPPER {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    position: relative;
  }

  .LOADINGBGCONTENT {
    height: 110%;
    width: 20%;
  }

  .LOADINGBGCONTENT2 {
    height: .6rem;
    width: 75%;
  }

  .LOADINGBGCONTENT3 {
    height: .6rem;
    width: 65%;
  }

  .LOADINGBGCONTENT4 {
    height: .6rem;
    width: 85%;
  }

  .card-header-title {
    word-break: break-word;
    font-size: 90%;
  }

  .short-link {
    color: #00d1b2;
    cursor: pointer;
    text-decoration: none;
    transition: none 86ms ease-out;
    position: relative;
  }

  .short-link::after {
    content: attr(data-label);
    color: #00d1b2;
    display: inline-block;
    position: absolute;
    top: -2px;
    left: 50%;
    opacity: .001;
    text-align: center;
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
    -webkit-backface-visibility: hidden;
    white-space: nowrap
  }

  .short-link.copying::after {
    -webkit-animation: floatup .5s ease-in-out;
    animation: floatup .5s ease-in-out
  }

  .has-disqus {
    margin-bottom: 30px;
  }

  .is-inline-block {
    padding-right: 10px;
  }

  .card-content-box {
    text-align: center;

  }

  @media screen and (min-width: 1000px) {
    .is-offset-sidebar-desktop {
      margin-left: 5.33333%;
    }
  }

  .adcode2 {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// FileInfo.vue?35a16084